import * as AppConstants from '@/utilities/AppConstants';

export interface Community {
  id: number,
  identity_id: number,
  name: string,
  domain: string,
  details: string,
  members_total: number,
  members_men: number,
  members_women: number,
  members_total_lastmonth: number,
  members_men_lastmonth: number,
  members_women_lastmonth: number,
  price_men: number,
  price_women: number,
  first_free: number,
  first_free_men: number,
  first_free_women: number,
  main_visual: number,
  main_community_file: number,
  approved: boolean,
  external_link: string | null,
  uniqueid: string,
  highlighted1: number,
  highlighted2: number,
  istest: boolean,
  /** Web payments enabled? */
  wpe: boolean,
  hasBackground: boolean,
  inviteonly: boolean,
}

export const UNKNOWN_COMMUNITY : Community = {
  id: -1,
  identity_id: -1,
  domain: AppConstants.HOST,
  name: "Unknown",
  details: 'Community not found',
  members_total: 0,
  members_men: 0,
  members_women: 0,
  members_total_lastmonth: 0,
  members_men_lastmonth: 0,
  members_women_lastmonth: 0,
  price_men: 1,
  price_women: 1,
  first_free: 0,
  first_free_men: 0,
  first_free_women: 0,
  main_visual: -1,
  main_community_file: -1,
  approved: false,
  external_link: null,
  uniqueid: "unknown",
  highlighted1: -1,
  highlighted2: -1,
  istest: false,
  wpe: false,
  hasBackground: false,
  inviteonly: false,
};

export interface CommunityInfo {
  member_counts: number[][];
};
